import { Link } from "react-router";
import { Inbox, Pencil } from "lucide-react";
import { CreateButton } from "@/components/admin/create-button";
import { DataTable } from "@/components/admin/data-table";
import { DeleteButton } from "@/components/admin/delete-button";
import { List } from "@/components/admin/list";
import { Button } from "@/components/ui/button";

import { TopToolbar } from "../layout/TopToolbar";
import type { AutomationRule } from "../types";
import { actionTypeLabel } from "./automationModel";

export const AutomationRuleList = () => (
  <List
    title="Automation rules"
    actions={
      <TopToolbar>
        <Button asChild variant="outline" size="sm">
          <Link to="/automation_jobs" title="Back to the Outbox">
            <Inbox className="size-4" /> Outbox
          </Link>
        </Button>
        <CreateButton />
      </TopToolbar>
    }
    perPage={50}
    sort={{ field: "name", order: "ASC" }}
  >
    <DataTable rowClassName={() => "cursor-pointer"}>
      <DataTable.Col source="name" label="Rule" />
      <DataTable.Col
        source="to_stage"
        label="When stage becomes"
      />
      <DataTable.Col
        label="Action"
        render={(record: AutomationRule) =>
          `${actionTypeLabel(record.action_type)}${
            record.action_config?.designID
              ? ` · design ${record.action_config.designID}`
              : ""
          }`
        }
      />
      <DataTable.Col
        label="Enabled"
        render={(record: AutomationRule) => (record.enabled ? "Yes" : "No")}
      />
      <DataTable.Col
        label=""
        render={(record: AutomationRule) => (
          <div
            className="flex justify-end gap-2"
            onClick={(e) => e.stopPropagation()}
          >
            <Button asChild variant="outline" size="sm">
              <Link to={`/automation_rules/${record.id}`} title="Edit this rule">
                <Pencil className="size-4" /> Edit
              </Link>
            </Button>
            <DeleteButton size="sm" label="Remove" />
          </div>
        )}
      />
    </DataTable>
  </List>
);
